import { Directive, Input, OnInit, AfterViewInit, OnDestroy, ElementRef, Renderer2, Injector, Optional, Inject } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SesionService } from '../services/sesion.service';
import { debounceTime } from 'rxjs/operators';
import { IGOOGLEANALITYCSAWARE_INJECTIONTOKEN, IGoogleAnalitycsAware } from '../google-analitycs-aware';
import { NgFormDirective } from './ng-form.directive';
import { NgSelectComponent } from '@ng-select/ng-select';
import { LanguageService } from '../services/language.service';

@Directive({
  selector: '[ngModel]'
})
export class NgModelDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input() elementoErrores: any;
  @Input() textoEtiqueta: string;

  constructor(
    private model: NgModel,
    private langService: LanguageService,
    private element: ElementRef,
    private renderer: Renderer2,
    @Inject(IGOOGLEANALITYCSAWARE_INJECTIONTOKEN)
    @Optional() private gaComponent: IGoogleAnalitycsAware,
    @Optional() frm: NgFormDirective,
    @Optional() select: NgSelectComponent
  ) {
    if (frm) {
      this.subscriptionFormSubmitInvalido = frm.submitInvalido.subscribe(() => {
        if (frm.primerControlInvalido == this.model.control) {
          setTimeout(() => {
            if (select) {
              select.focus();
            } else {
              this.element.nativeElement.focus();
            }

          }, 20);
        }
      });
    }
  }

  private subscriptionStatusChange: Subscription;
  private subscriptionValueChanges: Subscription;
  private subscriptionFormSubmitInvalido: Subscription;


  ngOnInit() {
    if (this.gaComponent) {
      this.subscriptionValueChanges = this.model.control.valueChanges.subscribe(v => {
        if (this.model.dirty) {
          this.gaComponent.changed();
        }
      });
    }
  }


  ngOnDestroy() {
    if (this.subscriptionStatusChange) {
      this.subscriptionStatusChange.unsubscribe();
    }
    if (this.subscriptionValueChanges) {
      this.subscriptionValueChanges.unsubscribe();
    }
    if (this.subscriptionFormSubmitInvalido) {
      this.subscriptionFormSubmitInvalido.unsubscribe();
    }
  }

  ngAfterViewInit() {
    const elemento: HTMLElement = this.element.nativeElement;
    let elementoMensajeError: HTMLSpanElement;
    let etiqueta: HTMLLabelElement;
    let claseEtiquetaInvalido = 'label-invalido';
    let claseInvalido = 'invalido';
    if (elemento.parentElement.previousElementSibling && elemento.parentElement.previousElementSibling.tagName == 'LABEL') {
      etiqueta = (elemento.parentElement.previousElementSibling as HTMLLabelElement);
    } else if (elemento.parentElement && elemento.parentElement.tagName === 'LABEL') {
      etiqueta = (elemento.parentElement as HTMLLabelElement);
      claseEtiquetaInvalido = 'label-contenedora-invalido';
      claseInvalido = null;
    }

    if (etiqueta) {
      if (!this.textoEtiqueta) {
        this.textoEtiqueta = etiqueta.innerText.trim();
      }
      let id = elemento.id;
      if (!id) {
        elemento.id = this.model.name;
        id = elemento.id;
      }
      if (!etiqueta.htmlFor) {
        etiqueta.htmlFor = id;
      }
    }

    let mensajeElementoErrores: any;
    let conElementoErrores = false;
    this.subscriptionStatusChange = this.model.statusChanges
      .pipe(debounceTime(400))
      .subscribe((status: string) => {
        if (status === 'INVALID' && this.model.touched) {

          if (this.elementoErrores) {
            if (this.elementoErrores.innerText && this.elementoErrores.style.display === 'none') {
              this.renderer.setStyle(this.elementoErrores, 'display', null);
              this.renderer.addClass(this.elementoErrores, 'label-invalido');
              conElementoErrores = true;
            } else {
              if (!mensajeElementoErrores && !conElementoErrores) {
                mensajeElementoErrores = this.renderer.createText(this.mensajeError);
                this.renderer.appendChild(this.elementoErrores, mensajeElementoErrores);
                this.renderer.addClass(elemento, 'label-invalido');
                this.renderer.setStyle(this.elementoErrores, 'display', null);
              }
            }
          } else {
            if (!elementoMensajeError) {
              this.renderer.addClass(etiqueta, claseEtiquetaInvalido);
              elementoMensajeError = this.renderer.createElement('span');
              elementoMensajeError.innerText = this.mensajeError;

              this.renderer.appendChild(elemento.parentElement, elementoMensajeError);
              this.renderer.addClass(elementoMensajeError, claseEtiquetaInvalido);
              if (claseInvalido) {
                this.renderer.addClass(elemento, claseInvalido);
              }
            }
          }
        } else {
          if (this.elementoErrores) {
            if (mensajeElementoErrores) {
              this.renderer.removeChild(this.elementoErrores, mensajeElementoErrores);
              this.renderer.removeClass(elemento, 'label-invalido');
              mensajeElementoErrores = null;
              elementoMensajeError = null;
            } else {
              this.renderer.setStyle(this.elementoErrores, 'display', 'none');
            }
          } else {
            if (elementoMensajeError) {
              this.renderer.removeChild(elemento.parentElement, elementoMensajeError);
              etiqueta.classList.remove(claseEtiquetaInvalido);
              if (claseInvalido) {
                this.renderer.removeClass(elemento, claseInvalido);
              }
              elementoMensajeError = null;
            }
          }
        }
      });
  }

  private get mensajeError(): string {
    if (!this.model.errors) {
      return '';
    }

    let message = '';
    Object.keys(this.model.errors).forEach(nombreError => {

      const error = this.model.errors[nombreError];
      if (typeof error == 'string') {
        message = message + error + '\n';
      } else {
        const plantillaMensaje: string = this.langService.instant('Shared.' + nombreError + 'Validator');
        message = message + plantillaMensaje.replace('#textoEtiqueta', this.textoEtiqueta) + '\n';

        Object.keys(error).forEach(propiedad => {

          message = message.replace('#' + propiedad, error[propiedad]);
        });
      }

    });


    return message;
  }

}
